import React from "react"
import { Helmet } from "react-helmet"

import { SITE_NAME, OG_IMAGE_WIDTH, OG_IMAGE_HEIGHT, isResizedImage } from "../../seo/build-seo"
import serializeJsonLd from "../../seo/serialize-json-ld"

function Seo({
  metaTitle,
  metaDescription,
  description,
  title,
  image,
  type,
  locale = "pt-BR",
  canonical,
  noindex,
  structuredData,
}) {
  const resizedImage = isResizedImage(image)

  const meta = [
    { name: "description", content: metaDescription },
    { name: "robots", content: noindex ? "noindex, follow" : undefined },
    { property: "og:site_name", content: SITE_NAME },
    { property: "og:locale", content: "pt_BR" },
    { property: "og:title", content: title || metaTitle },
    { property: "og:description", content: description || metaDescription },
    { property: "og:type", content: type || "website" },
    { property: "og:image", content: image },
    { property: "og:image:width", content: resizedImage ? String(OG_IMAGE_WIDTH) : undefined },
    { property: "og:image:height", content: resizedImage ? String(OG_IMAGE_HEIGHT) : undefined },
    { property: "og:url", content: canonical },
    { name: "twitter:card", content: image ? "summary_large_image" : "summary" },
    { name: "twitter:title", content: title || metaTitle },
    { name: "twitter:description", content: metaDescription },
  ].filter(({ content }) => Boolean(content))

  const link = [
    {"rel": "icon",
     "type": "image/png",
     "href": "https://guararapes-meuambiente.s3.sa-east-1.amazonaws.com/favicon.ico"
    }
  ]

  if (canonical) {
    link.push({ rel: "canonical", href: canonical })
  }

  return (
    <Helmet
      title={metaTitle}
      htmlAttributes={{ lang: locale }}
      meta={meta}
      link={link}
      script={
        structuredData
          ? [{ type: "application/ld+json", innerHTML: serializeJsonLd(structuredData) }]
          : []
      }
    />
  )
}

export default Seo
